module.exports = __webpack_public_path__ + "img/document-icon-dark.b3361781.svg";